import { createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'

import {
  type AuthorEditPageTabsKeys,
  DEFAULT_AUTHOR_EDIT_PAGE_TAB,
} from '../lib/tabs'

// Gate
export const AuthorEditPageGate = createGate()

// Tab
export const authorEditPageTabChanged = createEvent<AuthorEditPageTabsKeys>()
export const $authorEditPageTab = createStore<AuthorEditPageTabsKeys>(
  DEFAULT_AUTHOR_EDIT_PAGE_TAB,
)
  .on(authorEditPageTabChanged, (_, payload) => payload)
  .reset(AuthorEditPageGate.close)
